import ServiceBase from './serviceBase';
import { FlowDocument, FlowDocumentServiceContract } from './types/Flow';

class FlowDocumentService extends ServiceBase implements FlowDocumentServiceContract {
  getDocuments = async (flowId: number, flowLap: number): Promise<FlowDocument[]> =>
    this.get<FlowDocument[]>(`flowdocuments/${flowId}/${flowLap}`);

  uploadDocument = async (
    flowId: number,
    flowLap: number,
    flowVersion: number,
    formData: FormData
  ): Promise<boolean> => {
    const result = await this.post<boolean>(
      `flowdocuments/${flowId}/${flowLap}/version/${flowVersion}`,
      formData
    );
    return result;
  };

  downloadDocument = async (flowId: number, flowLap: number, docId: number): Promise<boolean> => {
    await this.download(`flowdocuments/${flowId}/${flowLap}/${docId}`);
    return true;
  };

  deleteDocument = async (flowId: number, flowLap: number, docId: number): Promise<boolean> => {
    await this.delete(`flowdocuments/${flowId}/${flowLap}/${docId}`);
    return true;
  };
}

const flowDocumentService = new FlowDocumentService();

export default flowDocumentService;
